import './App.css';
import Login from './Components/Login';
import CustomerEnquiry from './Components/CustomerEnquiry';
import { Routes, Route } from 'react-router-dom';
import Topbar from './Components/Topbar';
import ProtectedRoute from './Components/ProtectedRoute';
import Dashboard from './Components/Dashboard';
import LeadsDataTable from './Components/LeadsDataTable';

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/customerenquiry" element={<CustomerEnquiry />} />

        {/* Protected Layout */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Topbar />
            </ProtectedRoute>
          }
        >
          {/* Nested protected routes */}
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="dg" element={<LeadsDataTable leadTypeID={1} />} />
          <Route path="roadsafetysolutions" element={<LeadsDataTable leadTypeID={2} />} />
          <Route path="acp" element={<LeadsDataTable leadTypeID={3} />} />
          <Route path="water" element={<LeadsDataTable leadTypeID={4} />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<h2>404 - Page Not Found</h2>} />
      </Routes>
    </div>
  );
}

export default App;
